import Vue from 'vue';
import VueMq from 'vue-mq';

/**
 * 'sm' => 0 > screenWidth < 770
 * 'md' => 770 >= screenWidth < 992
 * 'lg' => 992 >= screenWidth < 1200
 * 'xl' => 1200 >= screenWidth
 */
Vue.use(VueMq, {
  breakpoints: {
    sm: 770,
    md: 992,
    lg: 1200,
    xl: Infinity
  }
});
